import React from 'react';

const PageHeader = ({ label, title, description, children }) => (
  <header className="page-header">
    {label && <span className="page-label">{label}</span>}
    <h1 className="page-title">{title}</h1>
    {description && <p className="page-description">{description}</p>}
    {children}
  </header>
);

export default PageHeader;
